export const permissionsCompaniesReadonly = [
  "companies-full",
  "companies-readonly",
  "everything-full",
  "everything-readonly",
];
